






















































import {Component, Vue, Watch} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageShow from "@/components/ImageShow.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";

/**
 * Bu ekranın düzenlediği "site" ayarları. Kayıtta yalnızca bu anahtarlar
 * gönderilir; sunucu gönderilmeyenleri (ek kodlar, filigran vb.) korur.
 * Sitede hiç okunmayan "Sayfa Metinleri" alanları (bannerSlogan,
 * contactInfo, anasayfaBaslik… ve _en karşılıkları) kaldırıldı: panelden
 * değiştirilip sitede görünmemeleri "ayar yansımıyor" şikâyetine yol açıyordu.
 */
export class config {
    phone : string = "";
    phone2 : string = "";
    whatsapp : string = "";
    address : string = "";
    address2 : string = "";
    email : string = "";
    formEmail : string = "";
    workingHours : string = "";
    mapsUrl : string = "";
    mapsEmbedUrl : string = "";
    directionsUrl : string = "";
    instagram : string = "";
    facebook : string = "";
    youtube : string = "";
    linkedin : string = "";
    x : string = "";
    tiktok : string = "";
}
@Component({
    components: {
        ImageUpload,
        ImageShow,
        Decimal,
        DeleteButton,EForm,Number,TextField,EnabledSwitch
    }
})
export default class SiteConfig extends  Vue{
    baseAction : string = ActionsEnum.Config;
    action : string = this.baseAction;
    data : config = new config();
    dialog : boolean = false;
    /** Formdaki verinin ait olduğu şube (sunucunun döndürdüğü _site_id) */
    loadedSiteId : number | null = null;
    loadedSiteName : string = "";
    loading : boolean = false;
    loadError : string = "";
    /** Üst üste binen yüklemelerde yalnızca sonuncusu forma yazılır */
    loadToken : number = 0;

    get activeSiteId() : number | null {
        const id = this.$store.getters.activeSiteId;
        return id === null || id === undefined || id === "" ? null : window.Number(id);
    }

    /**
     * Form yalnızca yüklenen veri aktif şubeye aitse gösterilir; şube
     * değiştiğinde eski şubenin değerleri yeni şubeye kaydedilemez.
     * (Kayıt sonrası aynı şubenin yeniden yüklenmesinde form gizlenmez;
     * gizlenirse EForm'un "İşlem başarılı" bildirimi de kayboluyordu.)
     */
    get formReady() : boolean {
        return this.loadError === "" && this.loadedSiteId !== null
            && (this.activeSiteId === null || this.activeSiteId === this.loadedSiteId);
    }

    async get(){
        const token = ++this.loadToken;
        this.loading = true;
        this.loadError = "";
        try{
            let response = await this.$http.get(this.action);
            if(token !== this.loadToken){
                return;
            }
            const source = response.data && typeof response.data === "object" ? response.data : {};
            const fresh : any = new config();
            Object.keys(fresh).forEach((key:string)=>{
                const value = source[key];
                if(value !== undefined && value !== null && typeof value !== "object"){
                    fresh[key] = String(value);
                }
            });
            this.data = fresh;
            this.loadedSiteId = source._site_id !== undefined && source._site_id !== null
                ? window.Number(source._site_id)
                : (this.activeSiteId !== null ? this.activeSiteId : 0);
            this.loadedSiteName = String(source._site_name || "");
            if(this.activeSiteId !== null && this.loadedSiteId !== this.activeSiteId){
                // Sunucu başka şubeyi döndürdü (ör. seçili şube silinmiş)
                this.loadError = "Sunucu seçili şubeyi tanımadı; üstteki şube seçicisinden şubeyi yeniden seçin.";
            }
        }catch (e) {
            if(token === this.loadToken){
                this.loadedSiteId = null;
                this.loadError = this.$helper.errorHandler(e) || "Sunucuya ulaşılamadı.";
            }
        }finally {
            if(token === this.loadToken){
                this.loading = false;
            }
        }
    }

    @Watch("$store.getters.activeSiteId")
    onActiveSiteChanged(){
        if(this.activeSiteId !== null && this.activeSiteId === this.loadedSiteId && !this.loading){
            return;
        }
        this.loadedSiteId = null;
        this.data = new config();
        this.get();
    }

    created(){
        this.get();
    }
};
